import React from "react";
import UserToClientList from "./UserToClientList";
import { RemovableUserToClient } from "components/Removables/RemovableUserToClient";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import { ModalPickerProps } from "../props";

interface Props extends ModalPickerProps<server.dto.UserToClientSmall>  {
  canChooseDeactivated?: boolean
  canChooseExternal?: boolean

  customLabel?: string
  excludeUsers?: number[]
}

const UserToClientModalPicker = (props: Props) => {
  const { canChooseDeactivated, canChooseExternal, customLabel, excludeUsers, ...rest } = props;

  return <ModalPickerWithChooseButton
    onNewClicked={() => { }}
    buttonLabel={RESX.Buttons.btnSelect}
    modalTitle={props.customLabel ?? RESX.SoUser.Users}
    modalSize="mini"
    
    renderModalContent={(closeModal) => <UserToClientList
      excludedUsers={props.excludeUsers}
      onUserSelected={(userToClient) => {
        closeModal();
        props.onChange(userToClient);
      }}
      canChooseDeactivated={props.canChooseDeactivated}
      canChooseExternal={props.canChooseExternal}
    />}
    renderRemovable={(props) => <RemovableUserToClient {...props} />}
    {...rest}
  />;
};

export default UserToClientModalPicker;